import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

enum ArrowRotation {
  'up' = 90,
  'down' = -90,
  'left' = 0,
  'right' = 180,
}

export const ArrowIcon = ({
  title = 'Arrow',
  direction = 'right',
  height = 24,
  width = 24,
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent
    title={title}
    viewBox="0 0 24 24"
    rotateDeg={ArrowRotation[direction]}
    height={height}
    width={width}
    {...props}
  >
    <g fill="none">
      {/* prettier-ignore */}
      <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* prettier-ignore */}
      <path d="M5 12L9 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* prettier-ignore */}
      <path d="M5 12L9 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </CreateIconComponent>
);

export default ArrowIcon;
